/** Icon DIM: hai gạch dóng và đường kích thước có mũi tên hai đầu. */
const DimensionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="self-stretch grow"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v12M15 3v12" />
    <path d="M3 9h12M3 9l2.5-2M3 9l2.5 2M15 9l-2.5-2M15 9l-2.5 2" />
  </svg>
);

export default DimensionIcon;
